/**
 * Feste Farbzuordnung je Sender.
 *
 * Bewusste Ausnahme vom Monochrom-Prinzip (Marvin, 2026-08-17), die zweite nach
 * der Kachelfarbe in TobisMarketCharts. Begruendung: in den TV-Diagrammen ist
 * der Sender die einzige ueber Tage hinweg konstante Groesse. Drei Abstufungen
 * desselben Violetts liessen sich in der Praxis nicht auseinanderhalten - und
 * eine Legende, die man bei jedem Balken erneut nachschlagen muss, kostet mehr
 * als die Farbe einbringt.
 *
 * Die Toene sind an die Sendermarken angelehnt (ARD blau, ZDF orange), aber
 * NICHT deren Markenfarben: die sind fuer einen warmen Papierhintergrund zu
 * grell. Genommen sind die gedeckten Toene aus SECTION_COLOR_PALETTE, damit die
 * Seite ein Farbsystem behaelt statt zweier nebeneinander.
 *
 * Reines Rot bleibt ausgespart, auch fuer RTL und ProSieben: es ist im
 * Designsystem fuer destruktive Aktionen reserviert (docs/ive-design-principles.md).
 * Senderfamilien teilen sich einen Ton, weil sie sich im Diagramm ohnehin nie
 * gegenseitig verdecken - die Dritten laufen unter dem ARD-Blau, ZDFneo unter
 * dem ZDF-Ocker.
 */
const ARD_BLAU = "#558caa";
const ZDF_OCKER = "#c8a641";
const RTL_TERRACOTTA = "#be7a55";
const P7S1_SALBEI = "#5a8c74";
const PFLAUME = "#93628a";
const PETROL = "#53938f";
const UMBRA = "#a86e48";
/** Alles ohne eigene Zuordnung, inklusive der Restgruppe "Andere". */
export const SENDER_FALLBACK = "#6f7d9b";

const EXAKT: Record<string, string> = {
  "ARD Das Erste": ARD_BLAU,
  ZDF: ZDF_OCKER,
  ZDFneo: ZDF_OCKER,
  RTL: RTL_TERRACOTTA,
  "RTL ZWEI": RTL_TERRACOTTA,
  RTLup: RTL_TERRACOTTA,
  "SAT.1": P7S1_SALBEI,
  "SAT.1 GOLD": P7S1_SALBEI,
  ProSieben: PFLAUME,
  "Kabel Eins": UMBRA,
  "VOX originär": PETROL,
  VOX: PETROL,
};

/**
 * Die Dritten fuehrt die AGF mit Sternchen und wechselnden Schreibweisen
 * ("NDR Fernsehen*", "SWR / SR Fernsehen*"). Statt jede Variante zu pflegen ein
 * Praefix-Abgleich - eine neue Landesrundfunkanstalt bekommt damit von selbst
 * das ARD-Blau.
 */
const DRITTE = ["NDR", "WDR", "MDR", "SWR", "BR", "HR", "RBB", "SR", "Radio Bremen", "ARD"];

export function senderColor(sender: string): string {
  const treffer = EXAKT[sender];
  if (treffer) return treffer;
  const name = sender.trim();
  if (DRITTE.some((p) => name.startsWith(p))) return ARD_BLAU;
  if (name.startsWith("ZDF")) return ZDF_OCKER;
  if (name.startsWith("RTL")) return RTL_TERRACOTTA;
  return SENDER_FALLBACK;
}
